import { DrawerItem } from 'helpers/drawer-config';
import { AccessElements } from 'helpers/app.config';

/**
 * searchMenuItems
 *
 * Busca en todos los niveles del menú y retorna resultados con breadcrumb jerárquico.
 * Solo incluye ítems a los que el usuario tiene permiso (mismo criterio que el menú visual).
 *
 * @param {string} query - El texto a buscar (mínimo 3 caracteres)
 * @param {DrawerItem[]} config - La configuración del menú a buscar
 * @param {(perms?: AccessElements[]) => boolean} hasPermission - Verifica permisos del usuario
 * @returns {SearchResult[]} Array de resultados encontrados
 */
export function searchMenuItems(
  query: string,
  config: DrawerItem[],
  hasPermission: (perms?: AccessElements[]) => boolean
): SearchResult[] {
  const results: SearchResult[] = [];
  const lowerQuery = query.toLowerCase();

  function searchRecursive(
    items: DrawerItem[],
    breadcrumb: string[] = []
  ): void {
    items.forEach((item) => {
      const itemTitle = String(item.title).toLowerCase();
      const currentBreadcrumb = [...breadcrumb, String(item.title)];

      // Solo agregar como resultado si el usuario tiene permiso sobre este ítem.
      // Se sigue recorriendo el submenu: un padre sin permiso no debe ocultar
      // hijos a los que sí tiene acceso (ej. Notification.Configure).
      if (
        hasPermission(item.permissions) &&
        item.path &&
        itemTitle.includes(lowerQuery)
      ) {
        results.push({
          path: item.path,
          breadcrumb: currentBreadcrumb.join(' > '),
          matchedText: String(item.title)
        });
      }

      if (item.submenu && item.submenu.length > 0) {
        searchRecursive(item.submenu, currentBreadcrumb);
      }
    });
  }

  searchRecursive(config);
  return results;
}

/**
 * SearchResult Interface
 *
 * Resultado de búsqueda con información para navegación
 */
export interface SearchResult {
  path: string;
  breadcrumb: string;
  matchedText: string;
}

